import { plugins, theme } from '@global-engineering-shared/gweb-material-theme-next';

import overrides from './overrides/';

export default {
  theme: {
    ...theme,
    overrides,
  },
  plugins,
};
